// Vendors
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { TxButton, TxButtonMode, TxLoadingText } from 'texkit-ui';

// Components
import { Trans } from '../../Trans';

// Helpers
import { clearAuthSession } from '../../../reducers/auth/authAuthorizeHelpers';

// Selectors
import { 
  selectTimeoutModalOpen, 
  selectAppUrl,
  selectAppName,
} from '../../../reducers/auth/authSelectors';

// Styles
import './timeout-modal.scss';

const TimeoutModal = () => {
  const isOpen = useSelector(selectTimeoutModalOpen);
  const appUrl = useSelector(selectAppUrl);
  const appName = useSelector(selectAppName);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleBackClick = () => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      clearAuthSession();
      window.location.href = appUrl;
    }
  };

  return (
    <div className="timeout-modal-backdrop" role="presentation">
      <div
        className="timeout-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="timeout-modal-title"
        aria-describedby="timeout-modal-description"
      >
        <h2 id="timeout-modal-title" className="timeout-modal-title">
          <Trans
            file="auth"
            id="timeoutTitle"
            fallback="This request timed out"
          />
        </h2>

        <p
          id="timeout-modal-description"
          className="timeout-modal-description"
        >
          <Trans
            file="auth"
            id="timeoutBodyPrefix"
            fallback="Go back to "
          />
          <strong className="timeout-modal-app-name">{appName}</strong>
          <Trans
            file="auth"
            id="timeoutBodySuffix"
            fallback=" and try again."
          />
        </p>

        {appUrl && (
          <div className="timeout-modal-actions">
            <TxButton
              className="timeout-modal-back-btn"
              mode={TxButtonMode.Primary}
              onClick={handleBackClick}
              disabled={isSubmitting}
              aria-busy={isSubmitting}
            >
              {isSubmitting ? (
                <TxLoadingText>
                  <Trans file="auth" id="goBack" fallback="Go back" />
                </TxLoadingText>
              ) : (
                <Trans file="auth" id="goBack" fallback="Go back" />
              )}
            </TxButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default TimeoutModal;
